import React from "react";
import Styles from "./AuctionHeader.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import { removeLocalStorageData } from "../../../commons/browserStorage";
const AuctionHeader = ({ heading, navigation }) => {
  const location = useLocation();
  let id = location?.search?.split("=")[1];
  console.debug(location);
  const navigate = useNavigate();
  const handleNav = (val) => {
    if (id) {
      return navigate(`${val}?id=${id}`);
    }
    navigate(`${val}`);
  };

  return (
    <div className={`display_flex_row ${Styles.auction_main_header}`}>
      <div className={`display_flex_row_gap_8_only`}>
        <div
          className={`display_flex_row_gap_8_only`}
          onClick={() => {
            removeLocalStorageData("activetenderId");
            navigate(-1);
          }}
        >
          <ArrowBackIosIcon style={{ fontSize: "12px" }} />
          <span className={Styles.back_button}>Back</span>
        </div>
        <div className={Styles.contenet_Header}>{heading}</div>
      </div>
      <div className={Styles.navigation_container}>
        {navigation?.map((ele) => (
          <div
            className={`${
              ele?.current
                ? Styles.active_nav_item
                : !ele?.current && ele?.active
                ? Styles.active_nav_view
                : Styles.active_nav_item_block
            }`}
            onClick={() => ele?.active && handleNav(ele?.link)}
          >
            {ele?.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuctionHeader;
